import { render, staticRenderFns } from "./PDFToolbar.vue?vue&type=template&id=bec9a5e2"
import script from "./PDFToolbar.vue?vue&type=script&lang=js"
export * from "./PDFToolbar.vue?vue&type=script&lang=js"
import style0 from "./PDFToolbar.vue?vue&type=style&index=0&id=bec9a5e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports